export const ACCEPT_IMAGE_FILES = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.png',
  '.webp',
  '.bmp',
  '.tiff',
  '.tif',
];
export const ACCEPT_CONTACT_FILES = ['.xls', '.csv', '.tsv', '.ods', '.xlsx'];
export const ACCEPT_DOC_FILES = ['.pdf', '.xls', '.xlsx', '.doc', '.docx'];
export const ACCEPT_VIDEO_FILES = [
  'video/*',
  '.mpg',
  '.avi',
  '.mov',
  '.mkv',
  '.mp4',
  '.webm',
  '.wmv',
];
export const MAX_FILE_SIZE_IN_BYTES = 100000000; // 100MB
export const MAX_FILENAME_LENGTH = 250;

export const FILE_ERROR_MESSAGE_TIMEOUT = 2700;

export const ACCEPT_IMAGE_MIME_TYPES_REGEX = /^image\/(png|svg\+xml|jpeg|jpg|gif)$/i;
export const ACCEPT_FAVICON_MIME_TYPES_REGEX =
  /^image\/(png|jpeg|jpg|ico|gif|vnd.microsoft.icon|x-icon)$/i;

export enum ImageAspectRatio {
  Landscape_21_9 = 21 / 9,
  Standard_4_3 = 4 / 3,
  Portrait_1_1 = 1 / 1,
}

export type UploadingStates = 'IDLE' | 'LOADING';
